export const feedbackLink = "Xna";
export default {feedbackLink};